import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  InputLabel
} from '@mui/material';
import '../../pages/Licenses/licenses.scss';
interface Props {
  showModal: boolean;
  closeModal: Function;
  handleSubmit: Function;
  onChangeValue: Function;
}

const ChangeMailModal = ({
  showModal,
  closeModal,
  handleSubmit,
  onChangeValue
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog className='dialog' fullWidth open={showModal} onClose={() => closeModal()}>
      <DialogTitle className='dialogTitle'>{t('CHANGE_ACCOUNT')}</DialogTitle>
      <DialogContent style={{ width: 400 }}>
        <InputLabel  style={{ marginTop: 20 }}>{t('NEW_MAIL')}</InputLabel>
        <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 }
        }}
          size='small'
          required
          id="name"
          type="email"
          fullWidth
          onChange={(e) => onChangeValue(e)}
        />
       
      </DialogContent>
      <DialogActions style={{ marginRight: 15, marginBottom: 15 }}>
        <Button variant='contained' onClick={() => handleSubmit()}>{t('CHANGE')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeMailModal;
